import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'int_square_root',
    dependencies: [
        'levels_maths/int_squared'
    ]
})


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoice([2, 3, 4, 5, 6, 7, 8, 10])
        q.addText('racine(' + (a * a) + ')')
        q.answer = a
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.fairChoice([0, 1, 2, 3, 4, 5, 6, 7, 8, 10])
        let b = random.intBetween(1, 3)
        q.addText('racine(' + (a * a) + ') + ' + b)
        q.answer = a + b
    },
    times: 2
})





export default level

